import React from 'react';
import { Add, AddBox, Percent, SwapHoriz, TrendingUp } from '@mui/icons-material';

export const getExperimentIcon = (type) => {
  switch (type) {
    case 'promo_combo_combinado':
      return <Add sx={{ fontSize: '12px' }} />;
    case 'promo_precio_unitario':
      return <Percent sx={{ fontSize: '12px' }} />;
    case 'reemplazo_producto':
      return <SwapHoriz sx={{ fontSize: '12px' }} />;
    case 'alza_precio_sugerido':
      return <TrendingUp sx={{ fontSize: '12px' }} />;
    case 'ampliar_carril':
      return <AddBox sx={{ fontSize: '12px' }} />;
    default:
      return null;
  }
};

export const getExperimentTypeText = (type, t) => {
  switch (type) {
    case 'promo_combo_combinado':
      return t('combo');
    case 'promo_precio_unitario':
      return t('discount');
    case 'reemplazo_producto':
      return t('reemplazo');
    case 'alza_precio_sugerido':
      return t('priceIncrease');
    case 'ampliar_carril':
      return t('laneExpansion');
    default:
      return '';
  }
};